<div class="db-add-website-optimize-only" dbCustomScrollbar>
  <div class="db-optimize-only__body" >
    <div class="db-optimize-only__download">
      <h1 class="db-optimize-only__title-l"
          [innerHTML]="('text_optimizeWebsite' | dbText)"></h1>
      <div>
        <img src="assets/images/backgrounds/booster-plugin-download.png" alt="">
      </div>
      <div>
        <button class="ds-btn-blue ds-btn-l db-check-download" (click)="downloadBoosterPlugin()">
          {{'text_downloadBoosterPlugin' | dbText}}
        </button>
        <div class="db-optimize-only__button-desc" [innerHTML]="'text_downloadBoosterPluginDesc' | dbText"></div>
      </div>
    </div>
    <div class="db-optimize-only__content">
      <h2 class="db-optimize-only__title-m">Free automated website optimization on any hosting</h2>
      <div class="db-optimize-only__separate-line"></div>
      <p class="db-optimize-only__subtitle"
         [innerHTML]="('text_optimizeWebsiteSubTitle'  | dbText )"></p>
      <div class="db-optimize-only__separate"></div>
      <h3 class="db-optimize-only__title-s center"><img src="assets/images/icons/point.svg" alt="">How to get started:</h3>
      <div class="db-optimize-only__section-wrap">

        <p class="db-optimize-only__text center">Follow these steps to connect and optimize your website with 10Web Booster.</p>
        <div>
          <div class="db-optimize-only__section db-optimization-steps">
            <div class="db-optimization-step1">
              <img src="assets/images/icons/zip_download-new.png" alt="">
              <p class="db-optimization-step-title"> Step 1 </p>
              <p class="db-optimization-step-desc"> Download 10Web Booster<br> plugin </p>
            </div>
            <div class="db-optimization-step2">
              <img src="assets/images/icons/activate_plugin-new.png" alt="">
              <p class="db-optimization-step-title"> Step 2 </p>
              <p class="db-optimization-step-desc"> Install and activate<br> it on your site </p>
            </div>
            <div class="db-optimization-step3">
              <img src="assets/images/icons/speed_score_90-new.png" alt="">
              <p class="db-optimization-step-title"> Step 3 </p>
              <p class="db-optimization-step-desc"> Get a 90+ PageSpeed and<br> pass Core Web Vitals </p>
            </div>
            <a class="db-button db-check-download" (click)="downloadBoosterPlugin()">
              <img src="assets/images/icons/download.svg" alt=""> {{'text_download' | dbText}}
            </a>
          </div>
          <div class="db-security-box">
            <img src="assets/images/icons/booster-icon.png" alt="">
            <div>
              <b>Thousands of websites are being optimized with 10Web Booster on a daily basis.</b>
              <p>Over 5000 active installs on WordPress.org.</p>
            </div>
          </div>
        </div>
      </div>
      <h3 class="db-optimize-only__title-s center last">
        <img src="assets/images/icons/point.svg" alt="">
        {{'text_get-booster-score' | dbText}}
      </h3>
      <div class="db-optimize-only__section-wrap">
      <p class="db-optimize-only__text center"
         [innerHTML]="('text_get-booster-score-desc'  | dbText )"></p>
      <div class="db-start-booster-blocks">
        <div class="db-start-booster-block-item" *ngFor="let block of blocks">
          <div class="db-start-booster-block-item-texts">
            <div class="db-start-booster-block-item-title" [innerHTML]="block.title"></div>
            <div class="db-start-booster-block-item-desc"  [innerHTML]="block.desc"></div>
          </div>
          <img [src]="block.img" alt="">
        </div>
      </div>
        </div>

      <button class="ds-btn-blue ds-btn-l db-check-download" (click)="downloadBoosterPlugin()">
       {{'text_downloadBoosterPlugin' | dbText}}
      </button>
      <div class="db-speed-booster__button-desc" [innerHTML]="'text_downloadBoosterPluginDesc' | dbText"></div>
    </div>
  </div>
</div>
